import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import { CustomTab, TabTitle } from './styles';
export const Tab = ({ id, title, testId, component, isActive, disabled, onClick, img, titleSize = 'bodyButton', }) => {
    const { colors } = useTheme();
    const textColor = isActive ? colors.text.default : colors.text.secondary;
    const handleTabClick = () => {
        if (disabled)
            return;
        onClick(id);
    };
    return (_jsx(CustomTab, { "data-cy": testId, "data-testid": testId, disabled: disabled, isActive: isActive, onClick: handleTabClick, type: "button", children: component ? (component) : (_jsx(TabTitle, { titleType: "primaryBold", titleSize: titleSize, titleColor: textColor, title: title, img: img })) }));
};
//# sourceMappingURL=Tab.js.map